<template>
    <RecommendedDriver :isPublic="true" :prop-recommended-query-params=this.typeNumberQueryParam :prop-product-name=null></RecommendedDriver>
</template>

<script>
import RecommendedDriver from "../../components/parametric-search/RecommendedDriver";

export default {
    name: "recommended-driver-page",
    components: {
        RecommendedDriver,
    },
    computed: {
        typeNumberQueryParam() {
            return this.$route.query.typeNumber;
        }
    }
};
</script>
